import { formatDate } from '../../../utils/utils';
import { formatDateForInput } from '../../../utils/filters';

export default {
    async createFourthStepUpdateRequest(formData) {
        let request = {};

        if (formData.effectStartDate) {
            request.effectStartDate = formatDate(formData.effectStartDate);
        }

        if (formData.yearsToReview) {
            request.yearsToReview = formData.yearsToReview;
        }

        return request;
    },
    async createFormDataFromResponse(response) {
        let formData = {};

        if (response.effectStartDate) {
            formData.effectStartDate = formatDateForInput(response.effectStartDate);
        }

        if (response.yearsToReview) {
            formData.yearsToReview = response.yearsToReview;
        }

        return formData;
    }
};